import { ChangeEvent, Fragment, useEffect, useState } from "react"

import { css, cx } from "@emotion/css"
import { Checkbox } from "@material-ui/core"
import { useI18n } from "providers/I18n"
import { MbaConfiguration, MediaTypeMbaConfig } from "models/mba"

type Props = {
  data?: MbaConfiguration
  update: (
    variables: Partial<MbaConfiguration & { clientConfig?: string }>,
  ) => Promise<Partial<MbaConfiguration>> | void
  id?: string
  disabled?: boolean
  configScope?: "CAMPAIGN" | "CLIENT_AGENCY"
}

export const ExportSeparateSubmedias = (props: Props) => {
  const { t } = useI18n()
  const { data, update, id, disabled, configScope } = props
  const [_checked, setChecked] = useState<Record<string, boolean>>()

  const onUpdate = (updatedData: Partial<MediaTypeMbaConfig>[] | undefined) => {
    update({ id, configScope, mediaTypes: updatedData })
  }

  const onCheck =
    (name: string) => (_: ChangeEvent<HTMLInputElement>, checked: boolean) => {
      setChecked((s) => ({ ...s, [name]: checked }))
      const updatedChecked = { ..._checked, [name]: checked }
      const updatedData = data?.mediaTypes?.map((mt) => ({
        ...mt,
        splitPerSubMedia: updatedChecked?.[mt?.name ?? ""],
      }))

      onUpdate(updatedData)
    }

  useEffect(() => {
    const splitPerSubMedia = data?.mediaTypes?.reduce((obj, item) => {
      return { ...obj, [item?.name ?? ""]: item?.splitPerSubMedia }
    }, {}) as Record<string, boolean>
    setChecked(splitPerSubMedia)
  }, [data?.mediaTypes])

  return (
    <>
      <div className={styles.container}>
        <h5 className={cx("BodyBody-1BlackBold", styles.title)}>
          {`${t("mba.config.campaign.separateSubmedias")}: `}
        </h5>
        <div className={styles.checkboxes}>
          {Object?.keys(_checked ?? {})?.map((k, kidx) => (
            <Fragment key={kidx}>
              <Checkbox
                name={String(kidx)}
                size="medium"
                color="primary"
                checked={_checked?.[k]}
                onChange={onCheck(k)}
                disabled={disabled}
              />
              <div
                className={cx("BodyBody-2BlackRegular", {
                  [styles.disabled]: disabled,
                })}
              >
                {k}
              </div>
            </Fragment>
          ))}
        </div>
      </div>
    </>
  )
}

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  `,
  title: css`
    margin-bottom: var(--spacing-s);
  `,
  checkboxes: css`
    display: flex;
    align-items: center;
    margin-left: -9px;
  `,
  disabled: css`
    color: var(--grey);
  `,
}
